import React from 'react';
import { Check } from 'lucide-react';

export const BUREAU_PULL_OPTIONS = [
  { key: 'experian', label: 'Experian', scoreField: 'experian' },
  { key: 'transunion', label: 'TransUnion', scoreField: 'transunion' },
  { key: 'equifax', label: 'Equifax', scoreField: 'equifax' },
];

/** Build bureauPullScores from legacy per-bureau score fields on an application. */
export function bureauPullScoresFromApplication(application = {}) {
  if (application.bureauPullScores) return application.bureauPullScores;
  return {
    experian: application.experianScoreUsed ?? null,
    transunion: application.transunionScoreUsed ?? null,
    equifax: application.equifaxScoreUsed ?? null,
  };
}

/** Infer selected bureau when only legacy score fields exist. */
export function inferSelectedBureauPull(application = {}) {
  if (application.selectedBureauPull) return application.selectedBureauPull;
  const scores = bureauPullScoresFromApplication(application);
  const firstWithScore = BUREAU_PULL_OPTIONS.find((b) => scores[b.scoreField] != null);
  return firstWithScore?.key ?? null;
}

const BureauPullSelector = ({
  bureauPullScores = {},
  selectedBureauPull = null,
  onSelect,
  readOnly = false,
}) => (
  <div className="fg-bureau-pull-grid" data-testid="bureau-pull-selector">
    {BUREAU_PULL_OPTIONS.map((bureau) => {
      const score = bureauPullScores[bureau.scoreField];
      const isSelected = selectedBureauPull === bureau.key;
      return (
        <button
          key={bureau.key}
          type="button"
          data-testid={`bureau-pull-tile-${bureau.key}`}
          data-selected={isSelected}
          disabled={readOnly}
          aria-pressed={isSelected}
          onClick={() => {
            if (readOnly) return;
            // TODO: persist selectedBureauPull via application update API when backend is ready
            onSelect?.(isSelected ? null : bureau.key);
          }}
          className={`fg-bureau-pull-tile ${isSelected ? 'selected' : ''}`}
        >
          {isSelected ? (
            <span className="fg-bureau-pull-badge">
              <Check className="size-3" />
              Selected
            </span>
          ) : null}
          <span className="fg-bureau-pull-name">{bureau.label}</span>
          <span className="fg-bureau-pull-score">{score != null ? score : '—'}</span>
        </button>
      );
    })}
  </div>
);

export default BureauPullSelector;
